var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('b-card-header',[_c('h4',{staticClass:"mb-0"},[_vm._v(" "+_vm._s(_vm.title)+" ")])]),_c('b-row',[_c('echart-area-large',{attrs:{"dias":_vm.dias,"aum":_vm.aum}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }